/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../../public/upgrade/feature/restrictions/rental-length-settings/rental-length-settings.component';
import * as import1 from '@angular/core/src/change_detection/change_detection_util';
import * as import2 from '@angular/core/src/linker/view';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/render/api';
import * as import5 from '@angular/core/src/metadata/view';
import * as import6 from '@angular/core/src/linker/view_type';
import * as import7 from '@angular/core/src/change_detection/constants';
import * as import8 from '@angular/core/src/linker/component_factory';
import * as import9 from '../../../../../../public/upgrade/feature/restrictions/restrictions.service';
import * as import10 from '@angular/core/src/linker/query_list';
import * as import11 from '../../../../../../public/upgrade/shared/sara-select/sara-select.component';
import * as import12 from '../../../shared/sara-select/sara-select.component.ngfactory';
import * as import13 from '@ngx-translate/core/src/translate.pipe';
import * as import14 from '@ngx-translate/core/src/translate.service';
export class Wrapper_RentalLengthSettingsComponent {
  /*private*/ _eventHandler:Function;
  context:import0.RentalLengthSettingsComponent;
  /*private*/ _changed:boolean;
  /*private*/ _expr_0:any;
  /*private*/ _expr_1:any;
  /*private*/ _expr_2:any;
  subscription0:any;
  constructor(p0:any) {
    this._changed = false;
    this.context = new import0.RentalLengthSettingsComponent(p0);
    this._expr_0 = import1.UNINITIALIZED;
    this._expr_1 = import1.UNINITIALIZED;
    this._expr_2 = import1.UNINITIALIZED;
  }
  ngOnDetach(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
    (this.subscription0 && this.subscription0.unsubscribe());
  }
  check_min(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_0,currValue))) {
      this._changed = true;
      this.context.min = currValue;
      this._expr_0 = currValue;
    }
  }
  check_max(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_1,currValue))) {
      this._changed = true;
      this.context.max = currValue;
      this._expr_1 = currValue;
    }
  }
  check_errors(currValue:any,throwOnChange:boolean,forceUpdate:boolean):void {
    if ((forceUpdate || import3.checkBinding(throwOnChange,this._expr_2,currValue))) {
      this._changed = true;
      this.context.errors = currValue;
      this._expr_2 = currValue;
    }
  }
  ngDoCheck(view:import2.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import2.AppView<any>,componentView:import2.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import2.AppView<any>,_eventHandler:any,emit0:boolean):void {
    this._eventHandler = _eventHandler;
    if (emit0) { (this.subscription0 = this.context.rentalLengthChange.subscribe(_eventHandler.bind(view,'rentalLengthChange'))); }
  }
}
var renderType_RentalLengthSettingsComponent_Host:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,([] as any[]),{});
class View_RentalLengthSettingsComponent_Host0 extends import2.AppView<any> {
  _el_0:any;
  compView_0:import2.AppView<import0.RentalLengthSettingsComponent>;
  _RentalLengthSettingsComponent_0_3:Wrapper_RentalLengthSettingsComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_RentalLengthSettingsComponent_Host0,renderType_RentalLengthSettingsComponent_Host,import6.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'rental-length-settings',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_RentalLengthSettingsComponent0(this.viewUtils,this,0,this._el_0);
    this._RentalLengthSettingsComponent_0_3 = new Wrapper_RentalLengthSettingsComponent(this.injectorGet(import9.RestrictionsService,this.parentIndex));
    this.compView_0.create(this._RentalLengthSettingsComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import8.ComponentRef_<any>(0,this,this._el_0,this._RentalLengthSettingsComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.RentalLengthSettingsComponent) && (0 === requestNodeIndex))) { return this._RentalLengthSettingsComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._RentalLengthSettingsComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
    this._RentalLengthSettingsComponent_0_3.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const RentalLengthSettingsComponentNgFactory:import8.ComponentFactory<import0.RentalLengthSettingsComponent> = new import8.ComponentFactory<import0.RentalLengthSettingsComponent>('rental-length-settings',View_RentalLengthSettingsComponent_Host0,import0.RentalLengthSettingsComponent);
const styles_RentalLengthSettingsComponent:any[] = ([] as any[]);
var renderType_RentalLengthSettingsComponent:import4.RenderComponentType = import3.createRenderComponentType('',0,import5.ViewEncapsulation.None,styles_RentalLengthSettingsComponent,{});
export class View_RentalLengthSettingsComponent0 extends import2.AppView<import0.RentalLengthSettingsComponent> {
  _viewQuery_maxRentalLength_0:import10.QueryList<any>;
  _el_0:any;
  _text_1:any;
  _text_2:any;
  _el_3:any;
  _text_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _el_12:any;
  compView_12:import2.AppView<import11.SaraSelectComponent>;
  _SaraSelectComponent_12_3:import12.Wrapper_SaraSelectComponent;
  _text_13:any;
  _text_14:any;
  _text_15:any;
  _el_16:any;
  _text_17:any;
  _el_18:any;
  compView_18:import2.AppView<import11.SaraSelectComponent>;
  _SaraSelectComponent_18_3:import12.Wrapper_SaraSelectComponent;
  _text_19:any;
  _text_20:any;
  _text_21:any;
  _text_22:any;
  /*private*/ _expr_28:any;
  _pipe_translate_0:import13.TranslatePipe;
  /*private*/ _expr_30:any;
  _pipe_translate_1:import13.TranslatePipe;
  _map_32:any;
  _map_33:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import2.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_RentalLengthSettingsComponent0,renderType_RentalLengthSettingsComponent,import6.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import7.ChangeDetectorStatus.CheckAlways);
    this._expr_28 = import1.UNINITIALIZED;
    this._expr_30 = import1.UNINITIALIZED;
    this._map_32 = import3.pureProxy2((p0:any,p1:any):{[key: string]:any} => {
      return {
        name: p0,
        itemList: p1
      }
      ;
    });
    this._map_33 = import3.pureProxy2((p0:any,p1:any):{[key: string]:any} => {
      return {
        name: p0,
        itemList: p1
      }
      ;
    });
  }
  createInternal(rootSelector:string):import8.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._viewQuery_maxRentalLength_0 = new import10.QueryList<any>();
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'h5',new import3.InlineArray2(2,'class','modal-title eva-3-h5'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._text_2 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._el_3 = import3.createRenderElement(this.renderer,parentRenderNode,'h5',new import3.InlineArray2(2,'class','eva-3-p'),(null as any));
    this._text_4 = this.renderer.createText(this._el_3,'',(null as any));
    this._text_5 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','modal-border-bottom -eva-3-mt-xlg'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n    ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pb-sm'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n        ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'div',new import3.InlineArray2(2,'class','col -lg-3 -md-3 -sm-12'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'\n            ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_10,'sara-select',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_12 = new import12.View_SaraSelectComponent0(this.viewUtils,this,12,this._el_12);
    this._SaraSelectComponent_12_3 = new import12.Wrapper_SaraSelectComponent();
    this._text_13 = this.renderer.createText((null as any),'\n            ',(null as any));
    this.compView_12.create(this._SaraSelectComponent_12_3.context);
    this._text_14 = this.renderer.createText(this._el_10,'\n        ',(null as any));
    this._text_15 = this.renderer.createText(this._el_8,'\n        ',(null as any));
    this._el_16 = import3.createRenderElement(this.renderer,this._el_8,'div',new import3.InlineArray2(2,'class','col -lg-3 -md-3 -sm-12'),(null as any));
    this._text_17 = this.renderer.createText(this._el_16,'\n            ',(null as any));
    this._el_18 = import3.createRenderElement(this.renderer,this._el_16,'sara-select',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_18 = new import12.View_SaraSelectComponent0(this.viewUtils,this,18,this._el_18);
    this._SaraSelectComponent_18_3 = new import12.Wrapper_SaraSelectComponent();
    this._text_19 = this.renderer.createText((null as any),'\n            ',(null as any));
    this.compView_18.create(this._SaraSelectComponent_18_3.context);
    this._text_20 = this.renderer.createText(this._el_16,'\n        ',(null as any));
    this._text_21 = this.renderer.createText(this._el_8,'\n    ',(null as any));
    this._text_22 = this.renderer.createText(this._el_6,'\n',(null as any));
    this._pipe_translate_0 = new import13.TranslatePipe(this.parentView.injectorGet(import14.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_1 = new import13.TranslatePipe(this.parentView.injectorGet(import14.TranslateService,this.parentIndex),this.ref);
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_12,new import3.InlineArray4(4,'modelChange',(null as any),'change',(null as any)),this.eventHandler(this.handleEvent_12));
    this._SaraSelectComponent_12_3.subscribe(this,this.eventHandler(this.handleEvent_12),true);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_18,new import3.InlineArray4(4,'modelChange',(null as any),'change',(null as any)),this.eventHandler(this.handleEvent_18));
    this._SaraSelectComponent_18_3.subscribe(this,this.eventHandler(this.handleEvent_18),true);
    this._viewQuery_maxRentalLength_0.reset([this._SaraSelectComponent_18_3.context]);
    this.context.maxSelect = this._viewQuery_maxRentalLength_0.first;
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._text_2,
      this._el_3,
      this._text_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._text_14,
      this._text_15,
      this._el_16,
      this._text_17,
      this._el_18,
      this._text_19,
      this._text_20,
      this._text_21,
      this._text_22
    ]
    ),[
      disposable_0,
      disposable_1
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import11.SaraSelectComponent) && ((12 <= requestNodeIndex) && (requestNodeIndex <= 13)))) { return this._SaraSelectComponent_12_3.context; }
    if (((token === import11.SaraSelectComponent) && ((18 <= requestNodeIndex) && (requestNodeIndex <= 19)))) { return this._SaraSelectComponent_18_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import1.ValueUnwrapper();
    const currVal_12_0_0:any = this.context.errors['minRentalLength'];
    this._SaraSelectComponent_12_3.check_error(currVal_12_0_0,throwOnChange,false);
    const currVal_12_0_1:any = 'defaultMinDays';
    this._SaraSelectComponent_12_3.check_name(currVal_12_0_1,throwOnChange,false);
    const currVal_12_0_2:any = this._map_32('restrictions.rentalLengthSettings.minDuration',this.context.selectMinDurationList);
    this._SaraSelectComponent_12_3.check_messages(currVal_12_0_2,throwOnChange,false);
    const currVal_12_0_3:any = false;
    this._SaraSelectComponent_12_3.check_required(currVal_12_0_3,throwOnChange,false);
    const currVal_12_0_4:any = this.context.min;
    this._SaraSelectComponent_12_3.check_model(currVal_12_0_4,throwOnChange,false);
    this._SaraSelectComponent_12_3.ngDoCheck(this,this._el_12,throwOnChange);
    const currVal_18_0_0:any = this.context.errors['maxRentalLength'];
    this._SaraSelectComponent_18_3.check_error(currVal_18_0_0,throwOnChange,false);
    const currVal_18_0_1:any = 'defaultMaxDays';
    this._SaraSelectComponent_18_3.check_name(currVal_18_0_1,throwOnChange,false);
    const currVal_18_0_2:any = this._map_33('restrictions.rentalLengthSettings.maxDuration',this.context.selectMaxDurationList);
    this._SaraSelectComponent_18_3.check_messages(currVal_18_0_2,throwOnChange,false);
    const currVal_18_0_3:any = false;
    this._SaraSelectComponent_18_3.check_required(currVal_18_0_3,throwOnChange,false);
    const currVal_18_0_4:any = this.context.max;
    this._SaraSelectComponent_18_3.check_model(currVal_18_0_4,throwOnChange,false);
    this._SaraSelectComponent_18_3.ngDoCheck(this,this._el_18,throwOnChange);
    valUnwrapper.reset();
    const currVal_28:any = import3.inlineInterpolate(1,' ',valUnwrapper.unwrap(this._pipe_translate_0.transform('restrictions.rentalLengthSettings.title')),' ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_28,currVal_28))) {
      this.renderer.setText(this._text_1,currVal_28);
      this._expr_28 = currVal_28;
    }
    valUnwrapper.reset();
    const currVal_30:any = import3.inlineInterpolate(1,' ',valUnwrapper.unwrap(this._pipe_translate_1.transform('restrictions.rentalLengthSettings.description')),' ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_30,currVal_30))) {
      this.renderer.setText(this._text_4,currVal_30);
      this._expr_30 = currVal_30;
    }
    this.compView_12.internalDetectChanges(throwOnChange);
    this.compView_18.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_12.destroy();
    this.compView_18.destroy();
    this._SaraSelectComponent_12_3.ngOnDestroy();
    this._SaraSelectComponent_18_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
  }
  handleEvent_12(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.context.min = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'change')) {
      const pd_sub_1:any = ((<any>this.context.onMinSelected()) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
  handleEvent_18(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.context.max = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'change')) {
      const pd_sub_1:any = ((<any>this.context.onMaxSelected()) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/restrictions/rental-length-settings/rental-length-settings.component.ngfactory.ts